const fromToKey = require('./from-to-key');

/**
 * Iterate over all keys from a given object and translate each one using a given dictionary.
 * @param {Object} object - Object to translate the keys
 * @param {Object.<string, string>} dictionary - Dictionary to be used in translation
 * @param {Object} [options={compositeKeySeparator:''}]
 * @param {string} [options.compositeKeySeparator] - Used when translating a composite key with separators
 * @returns {Object}
 */
const processObject = (object, dictionary, options) => {
  return Object.entries(object).reduce((accumulator, [key, value]) => {
    accumulator[fromToKey(key, dictionary, options)] = fromTo(value, dictionary, options);

    return accumulator;
  }, {});
};

/**
 * Iterate over all elements from a given array, to process each element
 * @param {Object[]|any[]} arr
 * @param {Object.<string, string>} dictionary - Dictionary to be used in translation
 * @param {Object} [options={ compositeKeySeparator: '' }]
 * @param {string} [options.compositeKeySeparator] - Used when translating a composite key with separators
 * @returns {Object[]|any[]}
 */
const processArray = (arr, dictionary, options) => {
  return arr.map(item => fromTo(item, dictionary, options));
};

/**
 * Translate each key from a given object (or array of objects) based on a given dictionary.
 * Obs: when a key is not present in the dictionary it will not be changed.
 * @param {Object|Object[]} entity - Object or list of objects to translate the keys
 * @param {Object.<string, string>} dictionary - Dictionary to be used in translation
 * @param {Object} [options={ compositeKeySeparator: '' }]
 * @param {string} [options.compositeKeySeparator=''] - Used when translating a composite key with separators
 * @returns {Object|Object[]} - Object with translated keys
 */
const fromTo = (entity, dictionary, options = { compositeKeySeparator: '' }) => {
  if (Array.isArray(entity)) return processArray(entity, dictionary, options);
  if (
    typeof entity === 'object'
    && entity instanceof Object
    && !(entity instanceof Date)
  ) return processObject(entity, dictionary, options);

  return entity;
};

module.exports = fromTo;
